<div class="col-md-12 main-heading">
  <div class="d-flex">
    <a routerLink="/index">
      <div class="icon-heading"><img src="assets/images/pages-icon/backbtn.png" class="img-responsive"> </div>
    </a>
    <div class="caption-heading">Parking Stations</div>
  </div>
</div>
<div class="col-md-12 pagecustom">
  <div class="page-wrapper">
    <div class="row main-container boxscroll">
      <div class="block-section width-lg-metro" style="min-height: 539px; width: fit-content;">
        <div class="heading-m" style="height: 37px;">
        </div>
        <div class="list-sidebar">
          <table>
            <tbody>
              <tr>
                <!--<td *ngFor="let device of deviceList">!-->
                <td *ngFor="let device of sortByEntry('DEVICE_NAME')">
                  <div style="margin:16px; padding:4px; border: solid gray 1px; border-radius: 5px; width: 180px; height: 201px;" (if)="ExitMatch(device.DEVICE_NAME)==true">
                    <div style="text-align:center;">
                      <img src="assets/images/pages-icon/barrier-closed.png" style="width: 48px; float: left;" />
                      <div class="dropdown" style="float:right; margin-right:-12px;">
                        <button class="btn btn-link dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <span class="material-icons-outlined">
                            settings
                          </span>
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          
                          <button class="dropdown-item btn btn-link" (click)="DeviceAction(device.DEVICE_ID, 'POMC');" *ngIf="ExitMatchController(device.READING_FUNCTION)==true">
                            Permanent Opening
                          </button>
                          <button class="dropdown-item btn btn-link" (click)="DeviceAction(device.DEVICE_ID, 'CPOMC');" *ngIf="ExitMatchController(device.READING_FUNCTION)==false">
                            Permanent Opening
                          </button>

                          <button class="dropdown-item btn btn-link" (click)="DeviceAction(device.DEVICE_ID, 'NOMC');"  *ngIf="ExitMatchController(device.READING_FUNCTION)==true">
                            Normal Operation
                          </button>
                          <button class="dropdown-item btn btn-link" (click)="DeviceAction(device.DEVICE_ID, 'CNOMC');"  *ngIf="ExitMatchController(device.READING_FUNCTION)==false">
                            Normal Operation
                          </button>

                          <button class="dropdown-item btn btn-link"  *ngIf="ExitMatchController(device.READING_FUNCTION)==true">
                            Temporary Closing
                          </button>
                          
                        
                          <button class="dropdown-item btn btn-link" (click)="DeviceAction(device.DEVICE_ID, 'OAC');"  *ngIf="ExitMatchController(device.READING_FUNCTION)==true">
                            Opening with Auto Closing
                          </button>
                          <button class="dropdown-item btn btn-link" (click)="DeviceAction(device.DEVICE_ID, 'OPEN_GATE');"  *ngIf="ExitMatchController(device.READING_FUNCTION)==false">
                            Opening with Auto Closing
                          </button>
                          <button class="dropdown-item btn btn-link" (click)="DeviceAction(device.DEVICE_ID, 'APBR');"  *ngIf="ExitMatchController(device.READING_FUNCTION)==true">
                            Anti pass back Reset
                          </button>
                          <button class="dropdown-item btn btn-link" (click)="DeviceLogs(device.DEVICE_ID);"  *ngIf="ExitMatchController(device.READING_FUNCTION)==true">
                            Logs
                          </button>
                        </div>
                      </div>
                      <br />
                      <br />
                      <br />
                      <div >
                        <b>{{device.DEVICE_NAME}}</b>
                      </div>
                      <br />
                      <br />
                      <div style="margin-top: 36px;">
                        <table style="width:100%">
                          <tbody>
                            <tr>
                              <td>
                                <span class="material-icons-outlined" style="color: green;">
                                  warning
                                </span>
                              </td>
                              <td>
                                <span class="material-icons-outlined" style="color: yellow;">
                                  info
                                </span>
                              </td>
                              <td>
                                <span class="material-icons-outlined" style="color: red;">
                                  close
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <!--<td *ngFor="let device of deviceList">!-->
                <td *ngFor="let device of sortByExit('DEVICE_NAME')">
                  <div style="margin:16px; padding:4px; border: solid gray 1px; border-radius: 5px; width: 180px; height: 201px;" (if)="ExitMatch(device.DEVICE_NAME)==true">
                    <div style="text-align:center;">
                      <img src="assets/images/pages-icon/barrier-closed.png" style="width: 48px; float: left;" />
                      <div class="dropdown" style="float:right; margin-right:-12px;">
                        <button class="btn btn-link dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <span class="material-icons-outlined">
                            settings
                          </span>
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          
                          <button class="dropdown-item btn btn-link" (click)="DeviceAction(device.DEVICE_ID, 'POMC');" *ngIf="ExitMatchController(device.READING_FUNCTION)==true">
                            Permanent Opening
                          </button>

                          <button class="dropdown-item btn btn-link" (click)="DeviceAction(device.DEVICE_ID, 'CPOMC');" *ngIf="ExitMatchController(device.READING_FUNCTION)==false">
                            Permanent Opening
                          </button>

                          <button class="dropdown-item btn btn-link" (click)="DeviceAction(device.DEVICE_ID, 'NOMC');"  *ngIf="ExitMatchController(device.READING_FUNCTION)==true">
                            Normal Operation
                          </button>
                          <button class="dropdown-item btn btn-link" (click)="DeviceAction(device.DEVICE_ID, 'CNOMC');"  *ngIf="ExitMatchController(device.READING_FUNCTION)==false">
                            Normal Operation
                          </button>

                          <button class="dropdown-item btn btn-link"  *ngIf="ExitMatchController(device.READING_FUNCTION)==true">
                            Temporary Closing
                          </button>
                          <button class="dropdown-item btn btn-link" (click)="DeviceAction(device.DEVICE_ID, 'OAC');"  *ngIf="ExitMatchController(device.READING_FUNCTION)==true">
                            Opening with Auto Closing
                          </button>
                          <button class="dropdown-item btn btn-link" (click)="DeviceAction(device.DEVICE_ID, 'OPEN_GATE');"  *ngIf="ExitMatchController(device.READING_FUNCTION)==false">
                            Opening with Auto Closing
                          </button>
                          <button class="dropdown-item btn btn-link" (click)="DeviceAction(device.DEVICE_ID, 'APBR');"  *ngIf="ExitMatchController(device.READING_FUNCTION)==true">
                            Anti pass back Reset
                          </button>
                          <button class="dropdown-item btn btn-link" (click)="DeviceLogs(device.DEVICE_ID);"  *ngIf="ExitMatchController(device.READING_FUNCTION)==true">
                            Logs
                          </button>
                        </div>
                      </div>
                      <br />
                      <br />
                      <br />
                      <div >
                        <b>{{device.DEVICE_NAME}}</b>
                      </div>
                      <br />
                      <br />
                      <div style="margin-top: 36px;">
                        <table style="width:100%">
                          <tbody>
                            <tr>
                              <td>
                                <span class="material-icons-outlined" style="color: green;">
                                  warning
                                </span>
                              </td>
                              <td>
                                <span class="material-icons-outlined" style="color: yellow;">
                                  info
                                </span>
                              </td>
                              <td>
                                <span class="material-icons-outlined" style="color: red;">
                                  close
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<form [formGroup]="reasonForm" (ngSubmit)="onReasonSubmit()">
  <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#deviceActionReasonModal" id="deviceActionReasonModalButton" style="display: none;">
    Launch demo modal
  </button>
  <div class="modal fade" id="deviceActionReasonModal" tabindex="-1" role="dialog" aria-labelledby="deviceActionReasonModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="deviceActionReasonModalLabel">Please provide reason</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="deviceActionReasonModalCloseButton">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <input type="hidden" formControlName="deviceId" />
          <input type="hidden" formControlName="action" />
          <input type="hidden" formControlName="datetime" />

          <div class="form-group">
            <label>Reason</label>
            <input type="text" formControlName="reason" class="form-control input-box">
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary">Ok</button>
        </div>
      </div>
    </div>
  </div>
</form>

<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#deviceLogsModal" id="deviceLogsModalButton" style="display: none;">
  Launch demo modal
</button>
<div class="modal fade" id="deviceLogsModal" tabindex="-1" role="dialog" aria-labelledby="deviceLogsModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="deviceLogsModalCloseButton">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <style>
          .SELECT_DEVICE_LOG_LIST_THEAD, .SELECT_DEVICE_LOG_LIST_TBODY {
            display: block;
          }

            .SELECT_DEVICE_LOG_LIST_THEAD td,
            .SELECT_DEVICE_LOG_LIST_TBODY td {
              padding: 10px;
            }

          .SELECT_DEVICE_LOG_LIST_TBODY {
            height: 500px;
            overflow-y: auto;
            overflow-x: hidden;
            word-break: break-word;
            vertical-align: top;
          }
        </style>
        <table style="width: 100%;" class="ag-theme-alpine">
          <thead class="SELECT_DEVICE_LOG_LIST_THEAD">
            <tr>
              <td style="max-width: 200px; min-width: 100px; ">
                Date Time
              </td>
              <td>
                Message
              </td>
            </tr>
          </thead>
          <tbody class="SELECT_DEVICE_LOG_LIST_TBODY">
            <tr *ngFor="let ratedtl of SELECT_DEVICE_LOG_LIST">
              <td style="max-width: 200px; min-width: 100px; ">{{ratedtl?.ONDATE}}</td>
              <td>{{ratedtl?.MESSAGE}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
